import { Controller } from "@hotwired/stimulus"

export default class extends Controller { 
  static values = {
    epoch: String
  }
  static targets = ["time", "date"]
  connect() {
    const date = new Date(parseFloat(this.epochValue));
      
    this.dateTarget.innerText = date.toLocaleDateString();
    this.timeTarget.innerText = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    // get previous node
    const previousNode = this.element.previousElementSibling
    if (previousNode) {
      // get user_id attribute from previous node
      const previousMessageUserId = previousNode.getAttribute('data-user-id')
      // get user_id attribute from current node
      const currentMessageUserId = this.element.getAttribute('data-user-id')
      // set from_previous_user data attribute to true if previous user_id is the same as current user_id
      this.element.setAttribute('data-from-previous-user', previousMessageUserId === currentMessageUserId);

      
      const previousDate = new Date(parseFloat(previousNode.getAttribute('data-student-message-epoch-value')))
      if (date.toLocaleDateString() == previousDate.toLocaleDateString()) { 
        this.element.setAttribute('data-from-previous-date', true);
      }
    }
    
  }
}
